import { getV3dProcedures } from '../v3d-utils/get-v3d-procedures';

export const setActiveKeyframe = (frame: number) =>
  getV3dProcedures().setActiveFrameForAllAnimations(frame);
